import { isPropValid, media, styled } from '@migros/msrc-ui-kit';
import { getArticleHeight, getArticleHeightTablet } from '../../../helpers';
export const ArticleContainer = styled.div.withConfig({
  shouldForwardProp: isPropValid
})`
  position: relative;
  padding-bottom: ${props => `${getArticleHeight(props)}px`};

  ${props => media.tabletWideAndUp`
    padding-bottom: ${`${getArticleHeightTablet(props)}px`};
  `}
`;